import Axios from "axios";
import {
  AddMenuRequest,
  EditMenuRequest,
  GetAllMenusResponse,
  GetApplicationsResponse,
  //   GetMenuResponse,
  GetUserMenusByUserIdResponse,
} from "../models/menu.model";
import { ApiBaseUrl, Menu } from "../config/config";
import { ApiResultModel } from "../models/common.model";

// export const GetMenus = (): Promise<GetMenuResponse[]> => {
//   return Axios.get<ApiResultModel<GetMenuResponse[]>>(
//     ApiBaseUrl + Menu + "/GetMenus"
//   ).then((result) => {
//     return result.data.data;
//   });
// };

export const GetUserMenusByUserId = async (data: {
  id: number;
}): Promise<GetUserMenusByUserIdResponse[]> => {
  return await Axios.post<ApiResultModel<GetUserMenusByUserIdResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Menu + "/GetUserMenusByUserId",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetApplications = (): Promise<GetApplicationsResponse[]> => {
  return Axios.get<ApiResultModel<GetApplicationsResponse[]>>(
    ApiBaseUrl + Menu + "/GetApplications"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetAllMenus = async (data: {
  applicationId: string;
}): Promise<GetAllMenusResponse[]> => {
  return await Axios.post<ApiResultModel<GetAllMenusResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + Menu + "/GetAllMenus",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddMenu = async (
  data: AddMenuRequest
): Promise<{ id: number }> => {
  return await Axios.post<ApiResultModel<{ id: number }>>(
    // SERVIES_URL
    ApiBaseUrl + Menu + "/AddMenu",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteMenu = async (data: { id: number }): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + Menu + "/DeleteMenu",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const EditMenu = async (data: EditMenuRequest): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + Menu + "/EditMenu",
    data
  ).then((result) => {
    return result.data.data;
  });
};
